import React, { useEffect } from 'react'
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getAllInvites, acceptInvite } from "../../../../../redux/action/buyer"

function NewInvites() {
  const isLaptop = useMediaQuery({ query: "(max-width: 1350px)" });
  const dispatch = useDispatch()
  const { allInvites } = useSelector((pre) => pre?.allInvites);


  console.log(allInvites)

  useEffect(() => {
    dispatch(getAllInvites())
  }, [])

  return (
    <>
      {
        allInvites.map((item) => (
          <div className="flex plan-expired flex align-center space-between ">
            <div className="full-width align-center flex">
              <span className="flex align-center justify-center green announcement-banner">
                <b className="white-text">New Invite.</b>
              </span>

              <span className="announcement-banner-title">&nbsp;</span>

              <b className={`${isLaptop ? "p-1 font-14px" : "p-2"}`}>
                <span className="announcement-banner-message">
                  You have been invited by {item.industry?.organizationName} to participate in a new auction on CercleX E-Auction.
                </span>
              </b>
            </div>

            <button
              style={{
                width: "130px",
                marginRight: "10px",
              }}
              onClick={() => dispatch(acceptInvite(item._id))}
            >
              <u>Accept</u>
            </button>
          </div>
        ))
      }
    </>

  )
}

export default NewInvites